import Head from 'next/head';
import {useRouter} from 'next/router';
import React from 'react';

import {HeadSEO, useCanonicalUrl} from '@udemy/head-seo';

import {getLayout} from 'src/components/layout';
import {SchemaMarkup} from 'src/components/schema-markup/schema-markup.react-component';
import {META_DEFAULT_BASE_URL} from 'src/lib/constants';
import {PageProps} from 'src/types/page-props';

import {
    AggregatorCourseDirectoryContextProvider,
    CERTIFICATION_PREP_SEARCH_QUERY,
} from '../../components/aggregator-course-directory/providers/aggregator-course-directory-context-provider.react-component';
import {useSetupNavigation} from '../../hooks/use-setup-navigation';
import {
    CertificationPreparation,
    CertificationPreparationProps,
} from './certification-preparation.react-component';

export type CertificationPreparationPageFeatureProps = PageProps & CertificationPreparationProps;

export function CertificationPreparationPageFeature(
    props: CertificationPreparationPageFeatureProps,
) {
    const router = useRouter();
    const {url: canonicalUrl} = useCanonicalUrl(
        router as {locale: string; asPath: string},
        [],
        META_DEFAULT_BASE_URL,
    );
    useSetupNavigation();

    const metaProps = {
        title: gettext('Certification Prep Courses & Practice | Udemy'),
        description: gettext(
            'Prepare for IT, business & project management certifications with expert-led, affordable courses. Enjoy flexible, interactive lessons & practice exams on Udemy.',
        ),
    };

    // TODO: Update this schema markup
    const schemaMarkup = undefined;

    return (
        <>
            <HeadSEO
                title={metaProps.title}
                ogTitle={metaProps.title}
                description={metaProps.description}
                ogDescription={metaProps.description}
                ogLocale={process.env.I18N_PATH_TO_BUNDLE_MAP[props.locale]}
                canonicalUrl={canonicalUrl}
                assetPath={process.env.ASSET_PREFIX}
                headWrapper={Head}
            />
            {schemaMarkup && <SchemaMarkup schemaMarkup={schemaMarkup} />}
            <AggregatorCourseDirectoryContextProvider
                searchQueryOverride={CERTIFICATION_PREP_SEARCH_QUERY}
                initialCourseSearchResponse={props.courseSearchInitialData}
            >
                <CertificationPreparation {...props} />
            </AggregatorCourseDirectoryContextProvider>
        </>
    );
}

CertificationPreparationPageFeature.getLayout = getLayout;
